import BaseView from "scripts/views/baseView";
import MediaListView from "scripts/views/mediaListView";
import templateCurationsPageListSubPage from "templates/curationsPageListSubPage.hbs";

class CurationsPageListSubPageView extends BaseView {
  get template() {
    return templateCurationsPageListSubPage;
  }

  constructor(options) {
    super(options);

    this.mediaListView = this.addSubView(
      new MediaListView({
        collection: this.collection,
      }),
    );
  }

  render() {
    this.$el.html(
      this.template({
        curationCount: this.collection.length,
      }),
    );

    this.mediaListView
      .appendTo($("#bb-curations-page-list-sub-page-list-view-region"))
      .render();

    return this;
  }

  sync() {
    return this.mediaListView.fetch();
  }
}

export default CurationsPageListSubPageView;
